import { ConfigProvider, Drawer } from 'antd';
import styled from 'styled-components';
import { Button, Col, Colors, Text } from 'basic-ui-lib';
import ItemMenu, { ItemMenuProps } from './ItemMenu';

interface MenuActionMobileProps {
  open?: boolean;
  onClose?: () => void;
  listMenu?: ItemMenuProps[];
  onClickMenu?: (item: ItemMenuProps) => void;
}

const MenuActionMobile = ({ open, onClose, listMenu, onClickMenu }: MenuActionMobileProps) => {

	const handleItemClick = (item: ItemMenuProps) => {
		if (onClickMenu) {
			onClickMenu(item);
		}
		onClose?.();
	};

  return (
    <ConfigProvider>
      <StyledDrawer
        title={
          <DrawerHeader>
            <Text title_h6 semibold center>
              Action
            </Text>
          </DrawerHeader>
        }
        placement='bottom'
        closable={false}
        onClose={onClose}
        open={open}
        height='auto'
        footer={
          <Button type_cancel lg onClick={onClose} style={{ width: '100%' }}>
            Close
          </Button>
        }
        destroyOnClose
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <Col gap={0}>
          {listMenu?.map((item) => (
            <ItemMenu key={item.key} {...item} onClick={() => handleItemClick(item)} />
          ))}
        </Col>
      </StyledDrawer>
    </ConfigProvider>
  );
};

export default MenuActionMobile;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: ${Colors.neutral.bg[2]};
  }

  .ant-drawer-footer {
    padding: 16px 16px;
    box-shadow: 0px -4px 8px 0px #0000001a;
    background-color: ${Colors.neutral.bg[1]};
  }

  .ant-radio-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
`;

const DrawerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
